<template>
  <card-container-layout :borderColor="borderColor" :addShadow="true">
    <div class="mb-2">
      <default-card-title-component
        :text="displayAddress"
      ></default-card-title-component>
    </div>
    <property-icon-list
      :bed="bed"
      :bath="bath"
      :parking="parking"
    ></property-icon-list>
    <div
      class="report__property-overview-items-container"
      :style="styles.overviewItems"
    >
      <overview-details-item
        title="Report Date"
        :description="reportDate"
      ></overview-details-item>
      <overview-details-item
        title="Campaign Length"
        :description="campaignLength"
      ></overview-details-item>
      <overview-details-item
        title="Campaign Start"
        :description="campaignStart"
      ></overview-details-item>
      <overview-details-item
        title="Media Channels"
        :description="mediaChannels"
      ></overview-details-item>
      <overview-details-item
        title="Package"
        :description="campaignPackage"
      ></overview-details-item>
    </div>
  </card-container-layout>
</template>
<script>
import PropertyIconList from '../PropertyIcons/PropertyIconList.vue';
import CardContainerLayout from '../Common/CardContainerLayout.vue';
import DefaultCardTitleComponent from '../Common/DefaultCardTitleComponent.vue';
import OverviewDetailsItem from '../Common/OverviewDetailsItem.vue';
import { DEFAULT_BRAND_SECONDARY_COLOR } from '../constants';
export default {
  props: {
    displayAddress: String,
    bed: [String, Number],
    bath: [String, Number],
    parking: [String, Number],
    reportDate: String,
    campaignLength: String,
    campaignStart: String,
    mediaChannels: String,
    campaignPackage: String,
    gridSize: Number
  },
  components: {
    PropertyIconList,
    CardContainerLayout,
    DefaultCardTitleComponent,
    OverviewDetailsItem,
  },
  inject: ['getBrandSecondaryBackground'],
  computed: {
    borderColor() {
      const primary = this.getBrandSecondaryBackground();
      return primary ? primary : DEFAULT_BRAND_SECONDARY_COLOR;
    },
    styles() {
      const gridSize = this.gridSize || 4;
      const overviewItems = {
        gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
      };

      return {
        overviewItems,
      };
    },
  },
};
</script>

<style scoped>
.report__property-overview-items-container {
  margin-top: 24px;
  display: grid;
  gap: 12px;
}
</style>
